<div>
  <h2 class="title is-3 mb-5 is-underlined has-text-link pointer">
    <a routerLink="/catalogue/tools/{{ tool.slug }}">
      {{ tool.name | stripHtml }}
    </a>
  </h2>

  <span class="icon-text tool-relations">
    <span class="icon" *ngIf="tool.usageRights && tool.usageRights.length">
      <i class="icon icon-Select is-size-7 has-text-primary"></i>
    </span>
    <ng-container *ngFor="let usageRight of tool.usageRights">
      <span class="country-label sans content is-small">{{
        usageRight.name
      }}</span>
    </ng-container>
    <span class="icon" *ngIf="tool.approaches && tool.approaches.length">
      <i
        class="icon icon-TopicsRelatedtotheResults is-size-7 has-text-primary"
      ></i>
    </span>
    <ng-container *ngFor="let approach of tool.approaches">
      <span class="country-label sans content is-small">{{
        approach.name
      }}</span>
    </ng-container>
    <span class="icon" *ngIf="tool.countries && tool.countries.length">
      <i class="icon icon-Public is-size-7 has-text-primary"></i>
    </span>
    <span
      *ngFor="let country of tool.countries"
      class="country-label sans content is-small"
      >{{ country.name }}</span
    >
    <span class="icon">
      <i class="icon icon-Calendar is-size-7 has-text-primary"></i>
    </span>
    <span class="my-0 country-label sans content is-small"
      >Uploaded on {{ tool.publishedAt | date }}</span
    >
    <ng-container *ngIf="this.tool.duration">
      <span class="icon">
        <i class="icon icon-Hour is-size-7 has-text-primary"></i>
      </span>
      <span class="country-label sans content is-small">{{
        this.tool.duration
      }}</span>
    </ng-container>
  </span>

  <div class="my-5" [innerHtml]="tool.excerpt"></div>
  <div class="columns">
    <div class="column is-5" *ngIf="tool.objectives?.length">
      <!-- Tags -->
      <p class="is-size-6 mt-0 is-bold mb-4">Objective(s)</p>

      <div class="tags">
        <a
          class="tag m-r-xs m-b-xs has-text-danger pointer objective-link"
          *ngFor="let objective of tool.objectives"
          [routerLink]="['/catalogue/tools']"
          [queryParams]="{ objectiveIds: objective.id }"
          title="See tools for &quot;{{ objective.name }}&quot;"
          >{{ objective.name | stripHtml }}</a
        >
      </div>
    </div>
    <div
      class="column is-6"
      [ngClass]="{ 'is-offset-1': tool.objectives?.length }"
    >
      <p
        class="is-size-6 mt-0 is-bold mb-4"
        *ngIf="tool.lifecycles && tool.lifecycles.length"
      >
        Related lifecycle stage(s)
      </p>

      <a
        class="pointer coma-list-item content is-small"
        *ngFor="let lifecycle of tool.lifecycles"
        [routerLink]="['/catalogue']"
        [queryParams]="{ lifecycleIds: lifecycle.id }"
        title="See tools for &quot;{{ lifecycle.name }}&quot;"
        >{{ lifecycle.name | stripHtml }}</a
      >
    </div>
  </div>
</div>
